module.exports = __webpack_public_path__ + "img/arabic-logo.5b6085a0.jpg";